import React, { useState, useRef, useEffect } from "react";
import { TextField, Button } from "react-md";
import { agentSearchByTerm } from "requests/agent";
import { getPolicyInfo } from "requests/homeowner/ho";
import MGrid, { FILTER_TYPE_NONE } from "components/Shared/MGrid.tsx";
import MCard from "components/Shared/MCard.tsx";
import { phoneNumberFormatter } from "components/Shared/Formatters";
import { DATA_TYPE_PHONE_NUMBER } from "typeConstants/dataTypes";
import PropTypes from "prop-types";

const AgentSearch = ({
  controlIDNumber,
  onAgentSelected,
}) => {
  const [policyInfo, setPolicyInfo] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [agentSearchResults, setAgentSearchResults] = useState();
  const [selectedAgent, setSelectedAgent] = useState();
  const mounted = useRef(true);

  useEffect(() => {
    getPolicyInfo(controlIDNumber, p => setPolicyInfo(p), mounted);
    return () => mounted.current = false;
  }, []);

  const onSearch = () => {
    agentSearchByTerm(searchTerm, policyInfo.customerInfo.majorCompanyId, mounted, a => setAgentSearchResults(a));
  };

  const colDefs = [
    { key: "agentCode", width: 95, dataSource: "agentCode", name: "Agent Code" },
    { key: "agentName", dataSource: "agentName", name: "Agent Name" },
    { key: "emailAddress", dataSource: "emailAddress", name: "Email Address" },
    { key: "phoneNumber", width: 110, valueFormatter: phoneNumberFormatter, dataSource: "phoneNumber", name: "Phone" },
  ];

  colDefs.forEach(cd => cd.filterType = FILTER_TYPE_NONE);

  return policyInfo ?
    <div className="agent-search">
      {selectedAgent ?
        <>
          <MCard
            title="Agent Information"
            fields={[
              { label: "Code", value: selectedAgent.agentCode },
              { label: "Name", value: selectedAgent.agentName },
              { label: "Major Company", value: selectedAgent.majorCompanyName },
              { label: "Email", value: selectedAgent.emailAddress },
              { label: "Phone Number", value: selectedAgent.phoneNumber, dataType: DATA_TYPE_PHONE_NUMBER },
              { label: "Fax", value: selectedAgent.faxNumber, dataType: DATA_TYPE_PHONE_NUMBER },
            ]} />
          <div className="select-agent-buttons">
            <Button primary raised onClick={() => setSelectedAgent(null)}>Back</Button>
            <Button primary raised onClick={() => onAgentSelected(selectedAgent)}>Select</Button>
          </div>
        </>
        :
        <>
          <div className="search-controls">
            <TextField label="Search Text" onChange={v => setSearchTerm(v)} />
            <Button primary raised iconEl={<i className="md-icon material-icons">search</i>} onClick={() => onSearch()} />
          </div>
          {agentSearchResults && <MGrid
            columnDefinitions={colDefs}
            data={agentSearchResults}
            onRowClick={i => setSelectedAgent(agentSearchResults[i])}
          />}
        </>}
    </div>
    :
    <div>Loading Agent Search...</div>;
};

AgentSearch.propTypes = {
  controlIDNumber: PropTypes.number, //control id number is used to get the major company code for the agent search
  onAgentSelected: PropTypes.func, //called when an agent is selected
};

export default AgentSearch;
